import isGoogleAppointmentsLandingPage from "./isGoogleLandingPage";

const toggleLandingPageLoader = (attach: boolean) => {
  if (isGoogleAppointmentsLandingPage()) {
    const containerId = "loaderContainer";

    if (attach) {
      if (!document.getElementById(containerId)) {
        const container = document.createElement("div");
        container.id = containerId;
        container.classList.add("container");
        const loader = document.createElement("div");
        loader.classList.add("loader");
        container.appendChild(loader);
        document.body.appendChild(container);
      }
    } else {
      document.getElementById(containerId)?.remove();
    }
  }
};

export default toggleLandingPageLoader;
